import React from "react";
import { motion } from "framer-motion";
import { FaRegHandshake, FaCrown, FaDollarSign, FaUsers, FaRocket, FaShieldAlt, FaTrophy, FaLightbulb, FaGlobe } from "react-icons/fa";
import "./Timeline.css";

const Time = () => {
  return (
    <div className="timeline-container">
      {/* Timeline line */}
      <div className="timeline-line"></div>

      {/* Timeline items */}
      <div className="timeline-items">
        {/* First item */}
        <motion.div
          className="timeline-item"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          whileHover={{ scale: 1.05, boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)" }}
          transition={{ duration: 0.8, type: "spring", stiffness: 120 }}
          viewport={{ once: true }}
        >
          <div className="content">
            <FaRegHandshake className="icon" />
            <h3>Trust and Reliability</h3>
            <p>We build long-lasting relationships based on trust, transparency, and mutual respect with our clients.</p>
          </div>
        </motion.div>

        {/* Second item */}
        <motion.div
          className="timeline-item"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          whileHover={{ scale: 1.05, boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)" }}
          transition={{ duration: 0.8, delay: 0.2, type: "spring", stiffness: 120 }}
          viewport={{ once: true }}
        >
          <div className="content">
            <FaCrown className="icon" />
            <h3>Royalty Service</h3>
            <p>Experience premium services tailored for excellence, ensuring you stand out in your industry.</p>
          </div>
        </motion.div>

        {/* Third item */}
        <motion.div
          className="timeline-item"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          whileHover={{ scale: 1.05, boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)" }}
          transition={{ duration: 0.8, delay: 0.4, type: "spring", stiffness: 120 }}
          viewport={{ once: true }}
        >
          <div className="content">
            <FaDollarSign className="icon" />
            <h3>Best Prices in the Industry</h3>
            <p>Unbeatable prices without compromising quality. Maximize your ROI with our cost-effective solutions.</p>
          </div>
        </motion.div>

        {/* Fourth item */}
        <motion.div
          className="timeline-item"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          whileHover={{ scale: 1.05, boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)" }}
          transition={{ duration: 0.8, delay: 0.6, type: "spring", stiffness: 120 }}
          viewport={{ once: true }}
        >
          <div className="content">
            <FaUsers className="icon" />
            <h3>Customer Satisfaction</h3>
            <p>Your satisfaction is our mission. We go above and beyond to deliver exceptional experiences.</p>
          </div>
        </motion.div>

        {/* Fifth item */}
        <motion.div
          className="timeline-item"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          whileHover={{ scale: 1.05, boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)" }}
          transition={{ duration: 0.8, delay: 0.8, type: "spring", stiffness: 120 }}
          viewport={{ once: true }}
        >
          <div className="content">
            <FaRocket className="icon" />
            <h3>Innovative Solutions</h3>
            <p>Harnessing cutting-edge technology to solve modern challenges and drive your success.</p>
          </div>
        </motion.div>

        {/* Sixth item */}
        <motion.div
          className="timeline-item"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          whileHover={{ scale: 1.05, boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)" }}
          transition={{ duration: 0.8, delay: 1, type: "spring", stiffness: 120 }}
          viewport={{ once: true }}
        >
          <div className="content">
            <FaShieldAlt className="icon" />
            <h3>Quality Assurance</h3>
            <p>Rigorous quality control ensures top-tier results in every project we undertake.</p>
          </div>
        </motion.div>

        {/* Seventh item */}
        <motion.div
          className="timeline-item"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          whileHover={{ scale: 1.05, boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)" }}
          transition={{ duration: 0.8, delay: 1.2, type: "spring", stiffness: 120 }}
          viewport={{ once: true }}
        >
          <div className="content">
            <FaLightbulb className="icon" />
            <h3>Creative Ideas</h3>
            <p>We thrive on innovation, delivering creative solutions that set you apart from the competition.</p>
          </div>
        </motion.div>

        {/* Eighth item */}
        <motion.div
          className="timeline-item"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          whileHover={{ scale: 1.05, boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)" }}
          transition={{ duration: 0.8, delay: 1.4, type: "spring", stiffness: 120 }}
          viewport={{ once: true }}
        >
          <div className="content">
            <FaGlobe className="icon" />
            <h3>Global Presence</h3>
            <p>With a footprint in over 20 countries, we bring world-class solutions to a diverse clientele.</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Time;
